module.exports = __webpack_public_path__ + "img/hip.9047125c.svg";